import { InternalLink } from "../../Links";

type AdventCalendarTermsAndConditionsLinksProps = { year: number };

const AdventCalendarTermsAndConditionsLinks = ({ year }: AdventCalendarTermsAndConditionsLinksProps) => (
   <span className="block text-left text-sm leading-relaxed text-ink-brand-inverted">
      <span className="block">Bruk kontaktinformasjonen du benytter i jobbsammenheng.</span>{" "}
      <span className="block mt-2">
         Ved å melde deg på samtykker du til å motta e-post og sms angående TINE Handel Julekalender {year}, og du kan motta
         markedskommunikasjon i fremtiden i forbindelse med ditt kundeforhold hos TINE. Du kan melde deg av når som helst.
      </span>{" "}
      <span className="block mt-2">
         Les mer om{" "}
         <InternalLink href="/kampanjer/julekalender/vilkar" variant="inverted" className="inline">
            konkurranseregler og vilkår
         </InternalLink>
         .
      </span>
   </span>
);

export default AdventCalendarTermsAndConditionsLinks;
